import React from 'react'
import MerchantHeaderFooter, { COMPONENT_FOOTER } from '../merchantHeaderFooter'

const Footer = () => <MerchantHeaderFooter component={COMPONENT_FOOTER} />

export default Footer
